(($, Drupal, Swiper) => {
  /**
   * @file
   * Contains js for Layout Builder Carousel block.
   */

  /**
   * Initialize swiper carousels.
   */
  Drupal.behaviors.swiperCarouselInit = {
    attach: function attach(context) {
      $(".swiper", context).each(function () {
        // eslint-disable-next-line no-new
        new Swiper(this, {
          slidesPerView: "auto",
          spaceBetween: 10,
          breakpoints: {
            1200: {
              spaceBetween: 35,
            },
          },
          speed: 800,
          loop: true,
          allowSlidePrev: false,
          navigation: {
            nextEl: $(this).find(".carousel-button-next").get(0),
          },
        });
      });
    },
  };
})(jQuery, Drupal, Swiper);
